import { render } from "./NcrmContactNormalizationQueue.vue?vue&type=template&id=d203c894&scoped=true"
import script from "./NcrmContactNormalizationQueue.vue?vue&type=script&lang=js"
export * from "./NcrmContactNormalizationQueue.vue?vue&type=script&lang=js"

import "./NcrmContactNormalizationQueue.vue?vue&type=style&index=0&id=d203c894&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d203c894"]])

export default __exports__